
// Minimal App component without hooks to fix React dispatcher corruption
import React from "react";
import { Route, Routes } from "react-router-dom";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import Auth from "./pages/Auth";
import Profile from "./pages/Profile";
import Marketing from "./pages/Marketing";
import "./App.css";
import { Toaster } from "./components/ui/toaster";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import ErrorBoundary from "./components/ErrorBoundary";
import { AppShell } from "./components/AppShell";

function App() {
  return (
    <ErrorBoundary fallback={
      <div className="min-h-screen flex items-center justify-center bg-red-50">
        <div className="text-center p-8">
          <h1 className="text-2xl font-bold text-red-600 mb-4">Application Error</h1>
          <p className="text-gray-600 mb-4">Something went wrong. Please refresh the page.</p>
          <button 
            onClick={() => window.location.reload()}
            className="mt-4 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
          >
            Refresh Page
          </button>
        </div>
      </div>
    }>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Marketing />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/app" element={
            <ProtectedRoute>
              <AppShell>
                <Index />
              </AppShell>
            </ProtectedRoute>
          } />
          <Route path="/profile" element={
            <ProtectedRoute>
              <AppShell>
                <Profile />
              </AppShell>
            </ProtectedRoute>
          } />
          <Route path="/templates" element={
            <ProtectedRoute>
              <AppShell>
                <div className="p-8">
                  <h1 className="text-2xl font-bold mb-4">Templates</h1>
                  <p className="text-muted-foreground">Coming soon...</p>
                </div>
              </AppShell>
            </ProtectedRoute>
          } />
          <Route path="/recent" element={
            <ProtectedRoute>
              <AppShell>
                <div className="p-8">
                  <h1 className="text-2xl font-bold mb-4">Recent Whiteboards</h1>
                  <p className="text-muted-foreground">Coming soon...</p>
                </div>
              </AppShell>
            </ProtectedRoute>
          } />
          <Route path="/settings" element={
            <ProtectedRoute>
              <AppShell>
                <div className="p-8">
                  <h1 className="text-2xl font-bold mb-4">Settings</h1>
                  <p className="text-muted-foreground">Coming soon...</p>
                </div>
              </AppShell>
            </ProtectedRoute>
          } />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Toaster />
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
